
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 99.84 70.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M99.79 29c0 14.7.11 20.23 0 40.28-6.94.1-3.28 4.37-5.87-3.87C85.61 39 59.24 35.23 36 44.45c-5.42 2-10.6 4.71-16 6.83-1.22.48-3.53.45-4.24-.34C10.56 45.17 5.63 39.16 0 32.54 37.4 12.41 67.67 22.1 94.54 53.27V29"}}),_c('path',{attrs:{"fill":"currentColor","d":"M61.93 0H86.4v37.51c-7.59-4.57-15.34-9.18-23-13.93a3.84 3.84 0 01-1.4-2.79C61.87 14 61.93 7.23 61.93 0zM52.26 69.32H28c0-5.38-.09-10.79.1-16.18 0-.75 1.33-1.82 2.24-2.12 7-2.25 14.12-4.35 22-6.73zM62.37 44.89c11 .11 19.4 5.21 22.63 12.78 1.47 3.44 1 6.38 1 11.58H62.37zM52.5 0v17.76H28.19V0zM94.52 22h5.27v4.98h-5.27z"}})])
          )
        }
      }
    